import React from "react"

const SvgWantedly = props => (
  <svg viewBox="0 0 900 900"  {...props} >
    <path
      d="M100 208.6h100l150 362.1L400 450 300 208.6h100l50 120.7 50-120.7h100L500 450l50 120.7 150-362.1h100L600 691.4H500l-50-120.7-50 120.7H300z"
    />
  </svg>
)

export default SvgWantedly
